//Date functions used by securebookit
Date.prototype.dateAdd = function(p_Interval, p_Number){
	
	if(typeof p_Number != "number"){
		throw "The second parameter must be a number. \n You passed: " + p_Number;
	}

	switch(p_Interval.toLowerCase()){
		case "yyyy": {// year
			this.setFullYear(this.getFullYear() + p_Number);
			break;
		}
		case "q": {        // quarter
			this.setMonth(this.getMonth() + (p_Number*3));
			break;
		}
		case "m": {        // month
			this.setMonth(this.getMonth() + p_Number);
			break;
		}
		case "y":        // day of year
		case "d":        // day
		case "w": {        // weekday
			this.setDate(this.getDate() + p_Number);
			break;
		}
		case "ww": {    // week of year
			this.setDate(this.getDate() + (p_Number*7));
			break;
		}
		case "h": {        // hour
			this.setHours(this.getHours() + p_Number);
			break;
		}
		case "n": {        // minute
			this.setMinutes(this.getMinutes() + p_Number);
			break;
		}
		case "s": {        // second
			this.setSeconds(this.getSeconds() + p_Number);
			break;
		}
		case "ms": {        // second
			this.setMilliseconds(this.getMilliseconds() + p_Number);
			break;
		}
		default: {
			//throws an error so that the coder can see why he effed up and
			//a list of elegible letters.
			throw    "The first parameter must be a string from this list: \nyyyy, q, m, y, d, w, ww, h, n, s, or ms. You passed: " + p_Interval;
		}
	};
	return this;
};
var stripTime = function(d){
if(d instanceof Date){
d.setHours(0);
d.setSeconds(0);
d.setMinutes(0);
d.setMilliseconds(0);
return d;
}
};
Date.prototype.stripTime = function(){
return stripTime(this);
};
var parseISO8601 = function(dateStringInRange) {
dateStringInRange = dateStringInRange.replace(/\//g,"-");
	var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,
		date = new Date(),
		parts = isoExp.exec(dateStringInRange);

	if(parts) {
	  date.setFullYear(parts[1], (Number(parts[2]) - 1), parts[3]);
	}
	return date;
};

Date.parseISO8601 = parseISO8601;

function daysDifferent(fD,sD){
var firstDate = new Date(fD);
var secondDate = new Date(sD);
var dd = 0;
var secYear = secondDate.getYear();
while(true){
var firYear = firstDate.getYear();
if(firYear == secYear) break;
var years = secYear - firYear;
var daysAdd = years * 350;
firstDate.setDate(firstDate.getDate() + daysAdd);
dd+= daysAdd;
}
var secMonth = secondDate.getMonth();
while(true){
var firMonth = firstDate.getMonth();
if(firMonth == secMonth) break;
var months = secMonth - firMonth;
var daysAdd = months * 28;
firstDate.setDate(firstDate.getDate() + daysAdd);
dd+= daysAdd;
}
var secDate = secondDate.getDate();
while(true){
var firDate = firstDate.getDate();
if(firDate == secDate) break;
var daysAdd = secDate - firDate;
firstDate.setDate(firDate + daysAdd);
dd+= daysAdd;
}
return dd;
}

Date.daysDifferent = daysDifferent;

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */

var dateFormat = function () {
var
token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
timezoneClip = /[^-+\dA-Z]/g,
pad = function (val, len) {
val = String(val);
len = len || 2;
while (val.length < len) val = "0" + val;
return val;
};

// Regexes and supporting functions are cached through closure
return function (date, mask, utc) {
var dF = dateFormat;

// You can't provide utc if you skip other args (use the "UTC:" mask prefix)
if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
mask = date;
date = undefined;
}

// Passing date through Date applies Date.parse, if necessary
date = date ? new Date(date) : new Date;
if (isNaN(date)) throw SyntaxError("invalid date");

mask = String(dF.masks[mask] || mask || dF.masks["default"]);

// Allow setting the utc argument via the mask
if (mask.slice(0, 4) == "UTC:") {
mask = mask.slice(4);
utc = true;
}

var
_ = utc ? "getUTC" : "get",
d = date[_ + "Date"](),
D = date[_ + "Day"](),
m = date[_ + "Month"](),
y = date[_ + "FullYear"](),
H = date[_ + "Hours"](),
M = date[_ + "Minutes"](),
s = date[_ + "Seconds"](),
L = date[_ + "Milliseconds"](),
o = utc ? 0 : date.getTimezoneOffset(),
flags = {
d:    d,
dd:   pad(d),
ddd:  dF.i18n.dayNames[D],
dddd: dF.i18n.dayNames[D + 7],
m:    m + 1,
mm:   pad(m + 1),
mmm:  dF.i18n.monthNames[m],
mmmm: dF.i18n.monthNames[m + 12],
yy:   String(y).slice(2),
yyyy: y,
h:    H % 12 || 12,
hh:   pad(H % 12 || 12),
H:    H,
HH:   pad(H),
M:    M,
MM:   pad(M),
s:    s,
ss:   pad(s),
l:    pad(L, 3),
L:    pad(L > 99 ? Math.round(L / 10) : L),
t:    H < 12 ? "a"  : "p",
tt:   H < 12 ? "am" : "pm",
T:    H < 12 ? "A"  : "P",
TT:   H < 12 ? "AM" : "PM",
Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
};

return mask.replace(token, function ($0) {
return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
});
};
}();

// Some common format strings
dateFormat.masks = {
"default":      "ddd mmm dd yyyy HH:MM:ss",
shortDate:      "m/d/yy",
mediumDate:     "mmm d, yyyy",
longDate:       "mmmm d, yyyy",
fullDate:       "dddd, mmmm d, yyyy",
shortTime:      "h:MM TT",
mediumTime:     "h:MM:ss TT",
longTime:       "h:MM:ss TT Z",
isoDate:        "yyyy-mm-dd",
isoTime:        "HH:MM:ss",
isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
dateFormat.i18n = {
dayNames: [
"Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
"Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
],
monthNames: [
"Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
]
};

// For convenience...
Date.prototype.format = function (mask, utc) {
return dateFormat(this, mask, utc);
};
